import React from 'react';
import { Link } from 'react-router-dom';
import { Play } from 'lucide-react';

const SuccessBanner = () => {
  return (
    <section className="relative py-16 md:py-20 bg-white overflow-hidden">
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-[22px] bg-[#b30000] px-8 py-10 md:px-12 md:py-12">
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/15 via-transparent to-black/15" />

          <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">

            {/* Left — headline + subtitle */}
            <div className="max-w-xl">
              <h3 className="text-4xl md:text-5xl font-extrabold leading-[1.05] tracking-[-0.03em] text-white">
                Lerne den <em className="not-italic oblique">Qur'an</em>
                <br />
                in seiner eigenen
                <br />
                Sprache.
              </h3>
              <p className="mt-4 text-[15px] text-white/70 font-normal">
                Sechs Live-Kurse · auf Deutsch erklärt · in kleinen Gruppen.
              </p>
            </div>

            {/* Right — buttons */}
            <div className="flex flex-col sm:flex-row lg:flex-col xl:flex-row items-start sm:items-center gap-3 shrink-0">
              <Link
                to="/anmelden"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-[15px] font-semibold text-[#970000] transition-colors duration-200 hover:bg-[#f5f0ef]"
              >
                <Play className="h-3.5 w-3.5 fill-[#970000]" />
                Jetzt anmelden
              </Link>

              <a
                href="#current-courses"
                className="inline-flex items-center justify-center rounded-full border border-white/30 px-6 py-3 text-[15px] font-semibold text-white transition-colors duration-200 hover:bg-white/10"
              >
                Kurse ansehen
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessBanner;
